module.exports = __webpack_public_path__ + "img/main_lx_bg.3070d05e.png";